var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTongs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    width: "50px",
    height: "50px",
    viewBox: "0 0 512 512",
    enableBackground: "new 0 0 512 512",
    xmlSpace: "preserve",
    fill: "#000000",
    transform: "rotate(-45)",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", {
    id: "grill_tongs"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#CBD0D8",
    d: "M256,511.996c-11.687,0-22.827-11.188-37.233-37.421c-8.921-16.25-15.64-32.219-15.921-32.891l19.671-8.25 c0.062,0.141,5.906,14.031,13.625,28.438c11.156,20.812,17.578,26.766,19.858,28.375c2.281-1.609,8.703-7.562,19.858-28.375 c7.719-14.406,13.562-28.297,13.625-28.438l19.672,8.25c-0.281,0.672-7,16.641-15.922,32.891 C278.827,500.809,267.688,511.996,256,511.996z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#A9B1BC",
    d: "M161.627,17.162c1.094,5.781-2.703,11.367-8.484,12.476c-5.781,1.102-11.375-2.695-12.468-8.484 c-1.109-5.789,2.687-11.375,8.468-12.476C154.94,7.577,160.518,11.374,161.627,17.162z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A9B1BC",
    d: "M166.049,38.037c1.109,5.781-2.688,11.367-8.484,12.469c-5.781,1.102-11.359-2.695-12.469-8.477 c-1.109-5.789,2.703-11.375,8.484-12.477S164.956,32.248,166.049,38.037z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A9B1BC",
    d: "M170.486,58.904c1.094,5.789-2.703,11.375-8.484,12.476c-5.797,1.102-11.375-2.695-12.484-8.484 c-1.094-5.781,2.703-11.367,8.484-12.469C163.799,49.326,169.377,53.123,170.486,58.904z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CBD0D8",
    d: "M199.751,274.282L149.143,8.678l0,0c-1.094-5.789-6.688-9.586-12.468-8.484 c-5.781,1.109-9.578,6.688-8.484,12.477c0,0,0,0.016,0.016,0.023l50.593,265.588L199.751,274.282z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#965353",
    d: "M249.094,456.544c1.094,5.797-2.703,11.375-8.484,12.484l-31.437,5.984 c-5.781,1.109-11.375-2.688-12.469-8.484l-51.905-272.432c-1.109-5.781,2.688-11.367,8.484-12.469l31.421-5.992 c5.797-1.102,11.375,2.695,12.484,8.484L249.094,456.544z"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "#7F4545",
    points: "160.643,277.235 213.298,268.642 209.298,247.681 156.643,256.267 "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#7F4545",
    points: "168.596,319.047 221.298,310.656 217.298,289.703 164.612,298.078 "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#7F4545",
    points: "176.564,360.874 229.298,352.655 225.298,331.687 172.58,339.905 "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#7F4545",
    points: "184.58,402.904 237.251,394.451 233.267,373.483 180.58,381.937 "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#A9B1BC",
    d: "M350.373,17.162c-1.094,5.781,2.703,11.367,8.484,12.476c5.781,1.102,11.375-2.695,12.483-8.484 c1.094-5.789-2.702-11.375-8.483-12.476C357.061,7.577,351.482,11.374,350.373,17.162z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A9B1BC",
    d: "M345.951,38.037c-1.108,5.781,2.688,11.367,8.484,12.469c5.781,1.102,11.359-2.695,12.469-8.477 c1.109-5.789-2.688-11.375-8.484-12.477C352.639,28.451,347.045,32.248,345.951,38.037z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A9B1BC",
    d: "M341.515,58.904c-1.094,5.789,2.703,11.375,8.483,12.476c5.797,1.102,11.375-2.695,12.484-8.484 c1.094-5.781-2.703-11.367-8.484-12.469C348.201,49.326,342.624,53.123,341.515,58.904z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CBD0D8",
    d: "M312.249,274.282L362.857,8.678l0,0c1.094-5.789,6.688-9.586,12.468-8.484 c5.781,1.109,9.578,6.688,8.484,12.477v0.023l-50.607,265.588L312.249,274.282z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#965353",
    d: "M262.906,456.544c-1.094,5.797,2.703,11.375,8.483,12.484l31.438,5.984 c5.781,1.109,11.375-2.688,12.469-8.484l51.905-272.432c1.109-5.781-2.688-11.367-8.484-12.469l-31.421-5.992 c-5.797-1.102-11.375,2.695-12.484,8.484L262.906,456.544z"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "#7F4545",
    points: "351.357,277.235 298.702,268.642 302.702,247.681 355.357,256.267 "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#7F4545",
    points: "343.405,319.047 290.702,310.656 294.702,289.703 347.389,298.078 "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#7F4545",
    points: "335.437,360.874 282.702,352.655 286.702,331.687 339.421,339.905 "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#7F4545",
    points: "327.421,402.904 274.749,394.451 278.733,373.483 331.421,381.937 "
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTongs);
export default __webpack_public_path__ + "static/media/tongs.a8ed0dcb57d1021c02ccd3932635bbee.svg";
export { ForwardRef as ReactComponent };